import { getCurrentLanguage } from 'utils/src/getCurrentLanguage';
import { apiClient } from '../../../../apps/crossword-maker/src/shared/apiClient';
import { ICrosswordBookWordEntity } from './CrosswordBook.api.types';

export interface ICopyWordFromDictionaryPayload {
	dictionaryWordIds: string[];
}

export type TCopyFromDictionary = (
	data: ICopyWordFromDictionaryPayload
) => Promise<ICrosswordBookWordEntity[]>;

export const copyFromDictionary: TCopyFromDictionary = async (data) => {
	const language = getCurrentLanguage();

	const response = await apiClient().post<ICrosswordBookWordEntity[]>(
		`/rest/${language}/crossword-book/word-category/from-dictionary`,
		data
	);

	return response.data;
};
